// Core
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

// Components
import Box from "components/Atoms/Box";
import Button from "components/Atoms/Button";
import Input from "components/Atoms/Input";
import Typography from "components/Atoms/Typography/TypographyV1";
import CoverLayout from "components/LayoutContainers/CoverLayout";
import Logo from "components/Logo";

// Images
import curved11 from "assets/images/curved-images/curved11.jpg";

// Redux
import { useSelector } from "react-redux";
import { selectThemeMode } from "state/application/applicationSlice";
import { useChangePasswordMutation } from "state/auth/authApiSlice";

function PasswordReset() {
  const navigate = useNavigate();
  const { token } = useParams();
  const themeMode = useSelector(selectThemeMode);
  // eslint-disable-next-line no-unused-vars
  const isDark = themeMode === "dark";

  const [password, setPassword] = useState("");
  const [passwordChanged, setPasswordChanged] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState(undefined);
  const [buttonText, setButtonText] = useState("Actualizar Password");
  const [changePassword] = useChangePasswordMutation();

  // eslint-disable-next-line consistent-return
  const handleSubmit = async (event) => {
    if (event) {
      event.preventDefault();
    }
    if (password !== confirmPassword) {
      return setError("The passwords do not match.");
    }
    try {
      await changePassword({ password, token }).unwrap();
      setButtonText("Password actualizada com sucesso! Será redireccionado para o login");
      setPasswordChanged(true);
      // Set a timeout for 2 seconds before navigating to the login page.
      setTimeout(() => {
        navigate("/login");
      }, 2000);
    } catch (err) {
      setError("There has been an error.");
    }
  };

  return (
    <CoverLayout
      image={curved11}
      header={
        <Box mb={2}>
          <Box mb={2}>
            <Logo size="medium" showSubtitle />
          </Box>
          <Typography
            variant="h3"
            fontWeight="bold"
            sx={{
              mb: 0.5,
              color: "#10b981",
              background: "linear-gradient(195deg, #10b981, #059669)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            }}
          >
            Password Reset
          </Typography>
          <Typography
            variant="body2"
            fontWeight="regular"
            sx={{ color: isDark ? "#cbd5e0" : "#718096" }}
          >
            Introduza a nova password e confirme a mesma
          </Typography>
        </Box>
      }
    >
      <Box component="form" role="form">
        <Box mb={2} lineHeight={1.25}>
          <Box mb={1} ml={0.5}>
            <Typography component="label" variant="caption" fontWeight="bold">
              Nova password
            </Typography>
          </Box>
          <Input
            onChange={(event) => setPassword(event.target.value)}
            type="password"
            placeholder="Nova Password"
            required
          />
        </Box>
        <Box mb={2} lineHeight={1.25}>
          <Box mb={1} ml={0.5}>
            <Typography component="label" variant="caption" fontWeight="bold">
              Confirme a password
            </Typography>
          </Box>
          <Input
            onChange={(event) => setConfirmPassword(event.target.value)}
            type="password"
            placeholder="Confirme a Password"
            required
          />
        </Box>
        <Box mt={2} mb={2} textAlign="center">
          <h6
            style={{
              fontSize: ".7em",
              color: "red",
              textAlign: "center",
              fontWeight: 400,
              transition: ".2s all",
            }}
          >
            {error}
          </h6>
        </Box>
        <Box mt={4} mb={1}>
          <Button
            onClick={handleSubmit}
            variant="gradient"
            buttonColor={passwordChanged ? "success" : "info"}
            disabled={passwordChanged}
            fullWidth
          >
            {buttonText}
          </Button>
        </Box>
      </Box>
    </CoverLayout>
  );
}

export default PasswordReset;
